module.exports = function toObject (mapKey, mapValue) {
  return function (array) {
    return array.reduce(
      function (reduction, next) {
        return { ...reduction, [ mapKey(next) ]: mapValue(next) }
      },
      {}
    )
  }
}
